import { render } from "./ModalRegisterAlert.vue?vue&type=template&id=228e0e6e&scoped=true"
import script from "./ModalRegisterAlert.vue?vue&type=script&lang=js"
export * from "./ModalRegisterAlert.vue?vue&type=script&lang=js"

import "./ModalRegisterAlert.vue?vue&type=style&index=0&id=228e0e6e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228e0e6e"]])

export default __exports__